export default __webpack_public_path__ + "static/ml-sub-banner-5382b1a3cf78251684b3b735663e5c8b.webp";